(function (angular) {
    "use strict";
    angular.module('mobilezuz').directive('spSpecialsList', ['Retailer', '$rootScope',
        function (retailer, $rootScope) {
            return {
                restrict: 'EA',
                templateUrl: 'views/templates/single-product-content.html',
                scope: {
                    vProduct:"=vProduct",
                    vOffer: "=vOffer",
                    specialsCtrl: "=specialsCtrl", // start  stupid code for backward compatibility
                    loyaltySpecialsListCtrl: "=loyaltySpecialsListCtrl",
                    lastMinuteRecommendationsCtrl: "=lastMinuteRecommendationsCtrl",
                    pickerCtrl: "=pickerCtrl",
                    groupBy: "=groupBy",
                    source: "@",
                    itemPosition: "@",
                    componentPosition: "@",
                    componentType: "@",
                    itemsCount: "@"
                },
                controllerAs: 'specialListItemCtrl',
                controller: function ($scope, Util) {
                    $scope.source = $scope.source || $rootScope.SP_SERVICES.SOURCES.SPECIALS;
                    $scope.resultsCount = $scope.resultsCount || $scope.itemsCount;
                    var specialListItemCtrl = this;
                    var _listeners =[];
                    retailer.getRetailerSettings().then(function (res) {
                        specialListItemCtrl.showSaleExperations = res.showSpecialsValidity;
                    });

                    _listeners.push($scope.$watch('vProduct', function(){
                        if(!$scope.vProduct){
                            return;
                        }
                        $scope.product = $scope.vProduct;
                    }));
                    _listeners.push($scope.$watch('vOffer', function(){
                        if(!$scope.vOffer){
                            return;
                        }
                        $scope.offer = $scope.vOffer;
                    }));
                    Util.destroyListeners($scope, _listeners);
                    $scope.handleAddAndToggle = function(offer, $event, isCase, itemsData ) {
                        $scope.$root.cart.addLine(
                          { product: offer.item, isCase: isCase },
                          null,
                          itemsData
                        );
                        var ctrl = $scope.specialsCtrl || $scope.loyaltySpecialsListCtrl || $scope.lastMinuteRecommendationsCtrl;
                        if (ctrl && angular.isFunction(ctrl.toggleView)) {
                          ctrl.toggleView($event, offer);
                        }
                      };
                },
                link: function ($scope, element, attrs) {
                    $scope.isSpecialPage = attrs.isSpecialPage === 'true';
                }
            };
        }]);
})(angular);
